// extracted by mini-css-extract-plugin
module.exports = {"card":"vrste-transporta-module--card--2ATKO","textContainer":"vrste-transporta-module--text-container--jTmHi"};